import { USER } from '../../../constants/role'
import { Outlet, useRoutes } from 'react-router-dom'
import ErrorPage from '../../../pages/errorPage/ErrorPage';
import { Component as UserDashboard } from 'pages/userDashboard/UserDashboard'
import useGetLayersByRoleAndClient from 'queryHooks/layerQueryHooks/useGetLayersByRoleAndClient';

export function Component() {
    const role = localStorage.getItem("role") ?? ""
    const roleId = localStorage.getItem("role_id");
    const { data = [] } = useGetLayersByRoleAndClient({ roleId: roleId as string })
    const routes = useRoutes([
        {
            path: "user-dashboard",
            element: <UserDashboard />,
        }
    ])

    if (role === USER) {
        return (
            <>
                <Outlet />
                {data.length > 0 && routes}
            </>
        )
    }

    return <ErrorPage message='Sorry, the page you are looking for could not be found.' />
}
